<template>
  <div class="login-page theme-audra">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-md-8">
          <div class="card login-box position-relative">
            <div class="overlay text-center" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>
            <div>
              <img :src="getImage('logo.svg')" alt="Dotlines" />
              <h3 class="card-common-title p-0 mb-3">Forgot your password?</h3>
              <form
                @submit.prevent="forget_pass()"
                method="POST"
                class="response-alert"
                novalidate
              >
                <div class="form-group">
                  <label class="control-label">Email</label>
                  <input
                    type="text"
                    id="mobile_or_email"
                    name="mobile_or_email"
                    v-model.trim="user.mobile_or_email"
                    class="form-control"
                    placeholder="Enter your email"
                    v-validate="'required'"
                    :class="{ 'has-error': errors.has('mobile_or_email') }"
                  />
                  <div class="help text-danger" v-show="errors.has('mobile_or_email')">
                    {{ `The Email feild is required.` }}
                  </div>
                </div>

                <button type="submit" class="btn btn-common btn-block mb-5">Send</button>

                <div class="text-center">
                  <router-link
                    class="pc fw-500 align-items-center d-inline-flex"
                    :to="{ name: 'Login' }"
                  >
                    <i style="font-size: 24px" class="icon-arrow-left-circle mr-2"></i>
                    Back to login
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-md-4 ml-auto d-none d-sm-block">
          <div class="login-img">
            <h2><span>Enterprise</span> Grade Internet <strong>Security</strong>.</h2>
            <img class="like" src="/assets/images/like.png" alt="like" />
            <img class="sheild" src="/assets/images/sheild.png" alt="sheild" />
            <img class="wifi" src="/assets/images/wifi.png" alt="wifi" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GuestLayout from "@/components/layouts/GuestLayoutComponent.vue";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: "Forgot Password | Dotlines",
      meta: [
        {
          name: "description",
          content: "The app built by Dotlines that is simply a framework",
        },
        {
          property: "og:title",
          content: "Forgot Password | Dotlines",
        },
      ],
    };
  },
  data: () => ({
    user: {},
    is_loading: false,
  }),
  methods: {
    forget_pass: function (e) {
      this.$validator.validateAll().then((result) => {
        const _this = this;
        if (result) {
          const api_url = this.API_BASE_URL + "/auth/forgot-password-v3";
          const token = "";
          const _this = this;
          this.is_loading = true;
          axios({
            method: "post",
            url: api_url,
            data: _this.user,
          })
            .then(function (response) {
              if (response.status === 200 && response.data.otp_success === true) {
                _this.user.mobile_or_email = "";
                $(".response-alert").prepend(
                  $(
                    `<div class="alert alert-success alert-dismissible fade show" role="alert">
            A reset password link has been sent to your registered email address. 
            Please check your email.
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>`
                  )
                );
                setTimeout(() => {
                  _this.$router.push({ name: "Login" });
                }, 5000);
              } else {
                $(".response-alert").prepend(
                  $(
                    `<div class="alert alert-danger alert-dismissible fade show" role="alert">
            ${response.data.message}
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>`
                  )
                );
              }
            })

            .catch(function (error) {
              if (error.response) {
                $(".response-alert").prepend(
                  $(
                    '<div class="alert alert-danger alert-dismissible fade show" role="alert">\n' +
                      error.response.data.message +
                      '    <button type="button" class="close" data-dismiss="alert" aria-label="Close">\n' +
                      '       <span aria-hidden="true">&times;</span>\n' +
                      "    </button>\n" +
                      "</div>"
                  )
                );
              } else if (error.request) {
                // The request was made but no response was received
                console.log(error.request);
              } else {
                // Something happened in setting up the request that triggered an Error
                console.log("Error", error.message);
              }
            })
            .finally(function () {
              _this.is_loading = false;
              _this.is_disabled = false;
              setTimeout(() => {
                $(".alert").fadeOut("slow");
              }, 5000);
            });

          console.warn(this.user);
        }
      });
    },
  },
  mounted: function () {
    // localStorage.setItem("authenticate", false);
    // localStorage.removeItem("token");
  },
  created() {
    this.$emit("update:layout", GuestLayout);
  },
};
</script>
